<template>
  <div>
    <Form :model="formData" :label-width="90" :rules="formRules" ref="formData">
      <Row :gutter="16">
        <Col span="7">
          <FormItem label="代理人手机号" prop="userPhone">
            <Input v-model="formData.userPhone"  @on-blur="changePhone"></Input>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="企业名称" prop="signName">
            <Input v-model="formData.signName" :disabled="disable"></Input>
          </FormItem>
        </Col>
        <Col span="9">
          <FormItem :label-width="90" label="企业地址" prop="businessAddress">
            <Input v-model="formData.businessAddress" :disabled="disable"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="16">
        <Col span="7">
          <FormItem label="代理人" prop="contactsName">
            <Input v-model="formData.contactsName" :disabled="disable"></Input>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="代理人邮箱" prop="contactsMail">
            <Input v-model="formData.contactsMail" :disabled="disable"></Input>
          </FormItem>
        </Col>
        <Col span="9" class="flex">
<!--          <FormItem :label-width="110" label="代理人身份证号" prop="contactsIdcard">-->
<!--            <Input v-model="formData.contactsIdcard" :disabled="disable"></Input>-->
<!--          </FormItem>-->
          <FormItem  class="flexnone" :label-width="90" label="代理人证件号" prop="contactsIdcardType">

            <Select style="width: 100px" v-model="formData.contactsIdcardType">
              <div v-if="createContractData">
                <Option v-for="item in createContractData.contacterTypeEnum" :value="item.value" :key="item.value">
                  {{item.text}}
                </Option>

              </div>

            </Select>
          </FormItem>

          <FormItem :label-width="1"  prop="contactsIdcard" class="flexauto">
            <Input v-model="formData.contactsIdcard" :disabled="disable" style="width: 100%;display: block"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row >
        <Col span="10">
          <FormItem :label-width="1" prop="businessQualification">
            <div class="flex">

              <Input style="margin-left: 10px;" :maxlength=20 class="flexauto" v-model="formData.businessQualification" placeholder="请输入证件号" >
                <Select  slot="prepend" v-model="formData.businessQualificationType" style="width: 100px"  class="flexnone">
                  <Option v-for="item in companyBusinessQualificationTypeList" :value="item.code" :key="item.code">
                    {{item.name}}
                  </Option>
                </Select>
              </Input>
            </div>

          </FormItem>
          <!--          <div class="flex">-->
          <!--            <FormItem label="" >-->
          <!--              <Select v-model="formData.companyBusinessQualificationType"  style="width: 80px" selected=1>-->
          <!--                <Option v-for="item in companyBusinessQualificationTypeList" :value="item.code" :key="item.code">-->
          <!--                  {{item.name}}-->
          <!--                </Option>-->
          <!--              </Select>-->
          <!--            </FormItem>-->
          <!--            <FormItem label="" >-->
          <!--              <Input v-model="formData.businessQualification" placeholder="请输入证件号" style="width: 140px"></Input>-->
          <!--            </FormItem>-->
          <!--          </div>-->
        </Col>
      </Row>
      <Row :gutter="16">
        <Col span="10">
          <div class="ivu-form-item-required ivu-form-item ">
            <span style="width:82px;" class="inline-b ivu-form-item-label" v-if="formData.businessQualificationType ===1">营业执照</span>
            <span style="width:82px;" class="inline-b ivu-form-item-label" v-if="formData.businessQualificationType ===3">法人证书</span>
            <div style="display:flex;">
              <div class="upload-wrap">
                <img class="imgwidth" v-if="formData.businessQualificationPic[0].url"
                     :src="formData.businessQualificationPic[0].url"
                     @click="showImg(formData.businessQualificationPic[0].url)"/>
                <Upload
                  :action="baseUrl+'/file/uploadFile'"
                  :on-success="setLicense1"
                  :headers="{'Access-Token':token}"
                  :show-upload-list="false"
                  :format="['jpg','jpeg','png']"
                  :on-format-error="handleFormatError"
                >
                  <div v-if="!formData.businessQualificationPic[0].url" class="upload"
                       :class="{error: !validateLicense1}">
                    <Icon type="ios-upload-outline" color="#DDDEE1" size="40" style="vertical-align: middle"></Icon>
                    <p>点击上传图片</p>
                  </div>
                  <a v-if="!formData.businessQualificationPic[0].url && !validateLicense1" class="error-color"
                     href="javascript:;">请上传企业资质证明</a>
                  <a v-if="formData.businessQualificationPic[0].url" href="javascript:;">修改</a>
                </Upload>
              </div>
            </div>
          </div>
        </Col>
        <Col span="10">
          <div class="ivu-form-item-required ivu-form-item ">
            <span style="width:110px;" class="inline-b ivu-form-item-label">租房事务委托书</span>
            <div class="upload-wrap">
              <img class="imgwidth" v-if="formData.proxyPic[0].url" :src="formData.proxyPic[0].url"
                   @click="showImg(formData.proxyPic[0].url)"/>
              <Upload
                :action="baseUrl+'/file/uploadFile'"
                :on-success="setProxy"
                :headers="{'Access-Token':token}"
                :show-upload-list="false"
                :format="['jpg','jpeg','png']"
                :on-format-error="handleFormatError"
              >
                <div v-if="!formData.proxyPic[0].url" class="upload" :class="{error: !validateProxy}">
                  <Icon type="ios-upload-outline" color="#DDDEE1" size="40" style="vertical-align: middle"></Icon>
                  <p>点击上传图片</p>
                </div>
                <a v-if="!formData.proxyPic[0].url && !validateProxy" class="error-color"
                   href="javascript:;">请上传租房事务委托书</a>
                <a v-if="formData.proxyPic[0].url" href="javascript:;">修改</a>
              </Upload>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span="20">
          <FormItem :label-width="250" label="客户通过哪些途径了解的该房源？(可多选)" prop="housePath">
            <Checkbox-group v-model="formData.housePath">
                <Checkbox v-for="(item,index) in housePaths"
                :key="'floor'+index"
                :label="item.value+':'+item.text"
                >{{item.text}}</Checkbox>
              </Checkbox-group>
          </FormItem>
        </Col>
      </Row>
    </Form>

  </div>
</template>

<script type="text/ecmascript-6">
  //组件from  CreateBusinessContract.vue

  import {getBaseUrl} from "@/utils/public";
  import {getToken} from "@/utils/auth";
  import {formatDateTime} from "@/utils/format";
  import {
    findCustomerQualification,
    getQualificationChooses
  } from "api/enterprisecontract";
  import {addCondition} from 'api/occupancy'

  export default {
    created() {
      this.baseUrl = getBaseUrl()
      this.token = getToken()
      getQualificationChooses().then(res => {
        res.data && (this.companyBusinessQualificationTypeList = res.data)
      }).catch(() => {
        return
      })
      addCondition()
      .then(res=>{
        this.housePaths = res.data.housePath;
      })
      // this.formData.businessQualificationType = this.companyBusinessQualificationTypeList[0].code
    },
    props: {
      n: {
        type: Number,
        default: 0
      },
      projectFid: {
        type: String,
        default: ''
      },
      roomsCount: {
        type: Number,
        default: 0
      },
      roomIds: {
        type: String,
        default: ''
      },
      createContractData: {
        type: Object,
        default: null
      },
    },
    data() {
      const validateContactPhone = (rule, value, callback) => {
        const pattern = /^1\d{10}$/

        //



        if (!pattern.test(value)) {
          this.disable = true
          callback(new Error('输入正确的联系方式'));
        } else {
          callback();

        }
      }
      const validateEmail = (rule, value, callback) => {
        const pattern = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        if (!pattern.test(value)) {
          callback(new Error('输入正确的邮箱'));
        } else {
          callback();
        }
      }
      // const validateId = (rule, value, callback) => {
      //   const pattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      //   if (!pattern.test(value)) {
      //     callback(new Error('输入正确的身份证号'));
      //   } else {
      //     callback();
      //   }
      // }
      const validateQualification = (rule, value, callback) => {
        const pattern = /^[A-Za-z0-9]+$/;
        if (!pattern.test(value) || value.length >20) {
          callback(new Error('输入正确的证件号'));
        } else {
          callback();
        }
      }
      const validatTujing = (rule, value, callback) => {
        if (value.length==0) {
          callback(new Error("请选择看房途径"));
        }
        callback();
      };
      return {
        housePaths:[],
        isClear: false,
        billingKey: 0,
        closeBillingKey: 0,
        isRead: true,
        show: false,
        baseUrl: '',
        token: '',
        disable: false,
        stockMaxSignDate: 0, // 最大签约日
        maxRentDay: 0,
        maxRentYear: 0,
        minRentDay: 0,
        minRentYear: 0,
        year: 0,
        month: 0,
        day: 0,
        rentTypeList: [],
        formData: {
          contactsIdcardType:null,
          housePath:[],

          subjectType: 3,
          customerUid: '',
          userPhone: '',
          signName: '',
          businessAddress: '',
          contactsName: '',
          contactsMail: '',
          contactsIdcard: '',
          businessQualification: '',
          businessQualificationType: 1, // 1 营业执照 2 法人证书
          businessQualificationPic: [
            {
              fid: '',
              url: ''
            }
          ],
          proxyPic: [
            {
              fid: '',
              url: ''
            }
          ]
        },
        validateLicense1: true,
        validateProxy: true,
        companyQualificationList: [],
        payTypeList: [],
        formRules: {
          contactsIdcardType:[{required: true, message: " ", trigger: "change", type: "number"}],

          userPhone: [{required: true, validator: validateContactPhone, trigger: 'blur'}],
          signName: [{required: true, message: ' ', trigger: 'blur', type: 'string'}],
          businessAddress: [{required: true, message: ' ', trigger: 'blur', type: 'string'}],
          contactsName: [{required: true, message: ' ', trigger: 'blur', type: 'string'}],
          contactsMail: [{required: true, validator: validateEmail, trigger: 'blur'}],
          contactsIdcard: [{required: true, trigger: 'blur'}],
          businessQualification: [{required: true, validator: validateQualification, type: 'string', trigger: 'blur'}],
          businessQualificationType: [{required: true, message: " ", trigger: "change", type: "number"}],
          housePath:[{required: true, message: "请选择了解途径", validator:validatTujing, trigger: "change"}]

        },
        discounts: null,
        paymentTermsDtos: [],
        creatdData: null,
        companyBusinessQualificationTypeList: []
      };
    },
    computed: {
      options1() {
        const _this = this
        const shortcuts = []

        const min = this.minRentYear
        let max = this.maxRentYear
        let temDate = 0
        // const temDateArr = []
        for (let i = min; i < max + 1; i++) {
          temDate = this.setDate(i)
          if (temDate.valueOf() > this.stockMaxSignDate) {
            max = i - 1;
            break;
          }
        }
        for (let i = min; i < max + 1; i++) {

          shortcuts.push({
            text: `${i}年`,
            value() {
              return _this.setDate(i)
            },
            onClick: (picker) => {
              _this.year = i
            }
          })
        }
        return {
          disabledDate(date) {
            return date && date.valueOf();
          },
          shortcuts: shortcuts
        }

      },
      options2() {
        const max = this.maxRentDay
        const min = this.minRentDay
        const now = new Date()

        let minTime = now.valueOf() + 3600 * 24 * 1000 * (min - 2)
        let maxTime = now.valueOf() + 3600 * 24 * 1000 * (max - 1)

        minTime = minTime > this.stockMaxSignDate ? this.stockMaxSignDate : minTime
        maxTime = maxTime > this.stockMaxSignDate ? this.stockMaxSignDate : maxTime
        return {
          disabledDate(date) {
            return date && date.valueOf() < minTime || date.valueOf() > maxTime;
          }
        }
      }
    },
    methods: {
      changePhone(){
        // //电话变了清理数据
        this.formData.signName = ""
        this.formData.businessAddress = ""
        this.formData.businessQualification = ""
        this.formData.contactsIdcard = ""
        this.formData.customerUid = ""
        this.formData.housePath = []

        const pattern = /^1\d{10}$/
        if (!pattern.test(this.formData.userPhone)) {
          return
        }

        findCustomerQualification(this.formData.userPhone).then(res => {
          this.disable = false
          this.formData.signName = res.data.companyName
          this.formData.businessAddress = res.data.companyAddress
          this.formData.businessQualification = res.data.businessLicence
          // this.formData.contactsName = res.data.contacterName
          this.formData.contactsIdcard = res.data.contacterNum
          this.formData.customerUid = res.data.customerUid
          // this.formData.contacterPhone = res.data.contacterPhone
          this.formData.contactsIdcardType=res.data.contactsIdcardType
        })

      },
      validate(){
        let re=null
        this.$refs['formData'].validate(bool=>{
          re=bool
        })
        this.validateLicense1=this.formData.businessQualificationPic[0].url?true:false
        this.validateProxy=this.formData.proxyPic[0].url?true:false
        return re && this.validateLicense1 && this.validateProxy
      },
      init(){
        this.clearData()

      },
      clearData() {
        this.formData.businessQualificationPic.forEach(item => {
          item.fid = ''
          item.url = ''
        })
        this.formData.proxyPic.forEach(item => {
          item.fid = ''
          item.url = ''
        })

        this.validateLicense1 = true
        this.validateProxy = true
        this.formData.customerUid = ''
        this.$refs['formData'].resetFields();
      },

      setLicense1(response) {
        this.formData.businessQualificationPic[0].fid = response.data.fid
        this.formData.businessQualificationPic[0].url = response.data.url
        this.validateLicense1 = true
      },
      setProxy(response) {
        this.formData.proxyPic[0].fid = response.data.fid
        this.formData.proxyPic[0].url = response.data.url
        this.validateProxy = true
      },
      handleFormatError() {
        this.$Message.error('请输入jpg,jpeg,png,格式的文件')
      },
      showImg(img) {
        this.$emit('show-img', img)
      },
    }
  }
</script>

<style lang="css" scoped>
  .box {
    padding-top: 24px;
    border-top: 1px solid #DDDEE1;
  }

  .imgwidth {
    width: 167px;
    height: 118px;
  }

  a {
    color: #CFA868;
  }

  .upload {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #DDDEE1;
    width: 167px;
    height: 118px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
  }

  .upload-wrap {
    display: inline-block;
    line-height: 1;
    padding: 10px 4px;
  }

  .ivu-date-picker {
    width: 100%;
  }

  .time-box {
    margin-left: 8px;
    display: inline-block;
    padding-left: 8px;
    padding-right: 8px;
    line-height: 30px;
    border: 1px solid #DDDEE1;
    border-radius: 2px;
  }

  .item {
    width: 200px;
  }

  .sup-icon {
    position: relative;
    top: -10px;
    left: -6px;
  }

  .activty-wrap {
    display: flex;
    align-items: center;
  }

  .activity-item {
    display: flex;
    line-height: 24px;
    margin-bottom: 12px;
  }

  .activity-item h4 {
    width: 80px;
    margin-right: 20px;
    text-align: right;
  }

  .activity-item p {
    color: #CFA868;
  }

  .upload {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #DDDEE1;
    width: 167px;
    height: 118px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;

  }

  .ivu-upload {
    position: relative;

  }

  .ivu-upload a {
    position: absolute;
    /*right: 0;*/
    bottom: -6px;
  }

  .upload.error {
    border-color: #F56356;
  }

  a.error-color {
    color: #F56356;
    bottom: -18px;

  }

  .tip-wrap {
    position: absolute;
  }

  .tip {
    display: none;
    position: absolute;
    bottom: 26px;
  }

  .sup-icon:hover + .tip {
    display: inline-block;
  }


</style>
